import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { PageUrl } from '../../pages/utils/page-url';
import { QueryKey, useUrl } from '../api';
import { getAppOrigin, sfccBaseGet } from '../sitegenesis';

export const useFooterEmailSignUpExclusionsHtml = (): UseQueryResult<string> => {
    const url = useUrl(PageUrl.PAGE_SHOW, [
        'cid',
        'email_signup_15_off_75_details',
        'format',
        'ajax',
    ]);
    let relativeUrl: string;
    try {
        const urlObj = new URL(url);
        relativeUrl = `${urlObj.pathname}${urlObj.search}`;
    } catch (e) {
        relativeUrl = url;
    }
    return useQuery<string>({
        queryFn: () =>
            sfccBaseGet<string>(() => `${getAppOrigin('')}${relativeUrl}`, [], undefined, false),
        queryKey: [QueryKey.EMAIL_SIGN_UP_OFFER_EXCLUSIONS],
        enabled: !!url,
    });
};
